module.exports = __webpack_public_path__ + "img/program_icon02.1fdc5623.png";